/**
 * @generated SignedSource<<bf76096e1d67ea9baa178a9031cbfb84>>
 * @relayHash ad62a06f6aa5632bfaade277e2ee9001
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c08aa1d76373e829f3bf7d2981babc4dbd15e62e4c9d7edeba93ba1675273988

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentUnifiedWithSpaceKeyQuery$variables = {
  agentSessionsPropertyKey?: string | null;
  fetchAgentSessionsMarker?: boolean | null;
  includeAgentTrustReceiptData?: boolean | null;
  includeAutomationDiscoveries?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeClassification?: boolean | null;
  includeReactions?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey: string;
  useContentModeFragment?: boolean | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentUnifiedWithSpaceKeyQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_space">;
    };
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentTitle_space">;
  } | null;
  readonly spaceHomepage: {
    readonly agentSessionsMarker?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly appearancePublished: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly archivedPageBannerStatusFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
    };
    readonly body: {
      readonly dynamic: {
        readonly content: {
          readonly id: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null;
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly superbatch: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly bylineClassificationFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"BylineClassification_content">;
    } | null;
    readonly commentsPanelPermission: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageCommentsPanelPermission_content">;
    };
    readonly contentClassification?: {
      readonly classificationLevelDetails: {
        readonly canManageSpaceSettings: boolean;
        readonly classificationControlSetting: string | null;
        readonly classificationLevel: {
          readonly color: string | null;
          readonly description: string | null;
          readonly guideline: string | null;
          readonly guidelineADF: string | null;
          readonly id: string;
          readonly name: string;
          readonly status: string;
        } | null;
        readonly featureEnabled: boolean;
        readonly isReclassificationPermitted: boolean;
        readonly source: ClassificationLevelSource | null;
        readonly userOverrideSetting: string | null;
      } | null;
      readonly id: string | null;
    } | null;
    readonly contentProperties: {
      readonly draft: {
        readonly contentMode: string | null;
      } | null;
      readonly latest: {
        readonly contentMode: string | null;
        readonly generatedBy?: string | null;
      } | null;
    } | null;
    readonly contentState: {
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null;
    readonly contentStateLastUpdated: {
      readonly value: string;
    } | null;
    readonly contentTitleWithByLine?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
    } | null;
    readonly coverPicture?: {
      readonly coverPictureProperties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
    } | null;
    readonly draftVersion: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
    readonly history?: {
      readonly createdBy: {
        readonly displayName: string | null;
      } | null;
      readonly createdDate: string | null;
    } | null;
    readonly id: string | null;
    readonly labels?: {
      readonly count: number | null;
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly label: string | null;
        readonly name: string | null;
        readonly prefix: string | null;
      } | null> | null;
    } | null;
    readonly macroRenderedOutput?: ReadonlyArray<{
      readonly key: string | null;
      readonly value: {
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    readonly meetingNotesAutomationDiscoveryFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"MeetingNotesAutomationDiscoveryFragment_content">;
    } | null;
    readonly metadata: {
      readonly frontend: {
        readonly collabService: string | null;
        readonly coverPictureWidth?: string | null;
        readonly embedded: boolean;
        readonly fabricEditorSupported: boolean | null;
      } | null;
      readonly lastModifiedDate: string | null;
    };
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_content">;
    };
    readonly pageRestrictionsContext?: {
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
    } | null;
    readonly pageRestrictionsContextAncestors?: {
      readonly ancestors: ReadonlyArray<{
        readonly hasRestrictions: boolean;
        readonly id: string | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly title: string | null;
      } | null> | null;
      readonly id: string | null;
    } | null;
    readonly pageTitlePublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly reactionsContent?: {
      readonly contentReactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly id: string | null;
    } | null;
    readonly reactionsContentFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ReactionsContentFragment_content">;
    } | null;
    readonly rendererCoverPicture?: {
      readonly " $fragmentSpreads": FragmentRefs<"CoverPictureQuery_content">;
    } | null;
    readonly rendererTitleContentProperties?: {
      readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesForPublishedPage_content">;
    } | null;
    readonly shareAndRestrictButtonData?: {
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
      readonly title: string | null;
    } | null;
    readonly smartFolderProperties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly space: {
      readonly alias: string | null;
      readonly id: string | null;
      readonly key: string | null;
      readonly name: string | null;
    } | null;
    readonly status: string | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly titleContentProperties?: {
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth: string | null;
        } | null;
      };
      readonly pageTitleDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly pageTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly type: string | null;
    readonly version: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly confRev: string | null;
      readonly contentTypeModified: boolean | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    } | null;
    readonly viewPageContentMode?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentModeFragmentProvider_content">;
    } | null;
    readonly viewPageLabels?: {
      readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
    } | null;
  } | null;
};
export type ContentUnifiedWithSpaceKeyQuery = {
  response: ContentUnifiedWithSpaceKeyQuery$data;
  variables: ContentUnifiedWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "agentSessionsPropertyKey"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAgentSessionsMarker"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscoveries"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useContentModeFragment"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v15 = [
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "type"
},
v19 = {
  "kind": "ScalarField",
  "name": "status"
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v21 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": (v20/*: any*/)
    },
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": (v20/*: any*/)
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "name"
},
v23 = {
  "kind": "ScalarField",
  "name": "color"
},
v24 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    {
      "kind": "ScalarField",
      "name": "restrictionLevel"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v25 = {
  "kind": "ScalarField",
  "name": "value"
},
v26 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v25/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v27 = {
  "kind": "ScalarField",
  "name": "title"
},
v28 = {
  "kind": "ScalarField",
  "name": "key"
},
v29 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v22/*: any*/),
    (v28/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "subType"
},
v31 = [
  (v28/*: any*/),
  (v25/*: any*/)
],
v32 = {
  "alias": "smartFolderProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v31/*: any*/)
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v33 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v34 = {
  "kind": "ScalarField",
  "name": "number"
},
v35 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v36 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v37 = [
  (v36/*: any*/)
],
v38 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v37/*: any*/)
},
v39 = {
  "kind": "ScalarField",
  "name": "when"
},
v40 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v41 = [
  {
    "kind": "ScalarField",
    "name": "coverPictureWidth"
  }
],
v42 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "kind": "ScalarField",
          "name": "embedded"
        },
        {
          "kind": "ScalarField",
          "name": "collabService"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v41/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v43 = {
  "kind": "ScalarField",
  "name": "representation"
},
v44 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v34/*: any*/)
  ]
},
v45 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v46 = [
  (v45/*: any*/)
],
v47 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v43/*: any*/),
        (v25/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v44/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v46/*: any*/)
            },
            (v45/*: any*/)
          ]
        }
      ]
    }
  ]
},
v48 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v16/*: any*/),
      (v28/*: any*/),
      (v25/*: any*/),
      (v44/*: any*/)
    ]
  }
],
v49 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v50 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v51 = {
  "alias": "pageTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": "properties(key:\"page-title-property-published\")"
},
v52 = {
  "alias": "pageTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": "properties(key:\"page-title-property-draft\")"
},
v53 = {
  "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
  "kind": "LinkedField",
  "name": "frontend",
  "plural": false,
  "selections": (v41/*: any*/)
},
v54 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v53/*: any*/)
  ]
},
v55 = {
  "alias": "coverPictureProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-draft",
        "cover-picture-id-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
},
v56 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v57 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v58 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v59 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v60 = {
  "kind": "ScalarField",
  "name": "count"
},
v61 = {
  "kind": "ScalarField",
  "name": "label"
},
v62 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v63 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v60/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v16/*: any*/)
      ]
    }
  ]
},
v64 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    (v27/*: any*/),
    (v57/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        }
      ]
    }
  ]
},
v65 = {
  "concreteType": "ClassificationLevelDetails",
  "kind": "LinkedField",
  "name": "classificationLevelDetails",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentDataClassificationLevel",
      "kind": "LinkedField",
      "name": "classificationLevel",
      "plural": false,
      "selections": [
        (v16/*: any*/),
        {
          "kind": "ScalarField",
          "name": "guideline"
        },
        {
          "kind": "ScalarField",
          "name": "guidelineADF"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v23/*: any*/),
        (v22/*: any*/),
        (v19/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "featureEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "source"
    },
    {
      "kind": "ScalarField",
      "name": "isReclassificationPermitted"
    },
    {
      "kind": "ScalarField",
      "name": "canManageSpaceSettings"
    },
    {
      "kind": "ScalarField",
      "name": "classificationControlSetting"
    },
    {
      "kind": "ScalarField",
      "name": "userOverrideSetting"
    }
  ]
},
v66 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v67 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v68 = {
  "condition": "isSSR",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MapOfStringToFormattedBody",
      "kind": "LinkedField",
      "name": "macroRenderedOutput",
      "plural": true,
      "selections": [
        (v28/*: any*/),
        {
          "concreteType": "FormattedBody",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            (v25/*: any*/),
            (v43/*: any*/),
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": (v46/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v69 = {
  "condition": "fetchAgentSessionsMarker",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "agentSessionsMarker",
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "agentSessionsPropertyKey"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v48/*: any*/)
    }
  ]
},
v70 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v71 = {
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "theme",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "themeKey"
    },
    (v22/*: any*/)
  ]
},
v72 = {
  "kind": "ScalarField",
  "name": "background"
},
v73 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v74 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v75 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v76 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v77 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v78 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v79 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v80 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v81 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v82 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v72/*: any*/),
    (v73/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/),
    (v76/*: any*/),
    (v77/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v72/*: any*/),
        (v73/*: any*/),
        (v74/*: any*/),
        (v75/*: any*/),
        (v76/*: any*/),
        (v77/*: any*/),
        (v78/*: any*/),
        (v79/*: any*/),
        (v80/*: any*/),
        (v81/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v83 = {
  "kind": "ScalarField",
  "name": "padding"
},
v84 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v85 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v72/*: any*/),
    (v73/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/),
    (v76/*: any*/),
    (v77/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v83/*: any*/),
    (v84/*: any*/)
  ]
},
v86 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v87 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v88 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v89 = [
  (v88/*: any*/),
  (v36/*: any*/)
],
v90 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v89/*: any*/)
},
v91 = {
  "kind": "ScalarField",
  "name": "sourceTemplateEntityId"
},
v92 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v93 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v94 = [
  (v88/*: any*/),
  (v18/*: any*/),
  (v36/*: any*/),
  (v92/*: any*/),
  (v93/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v21/*: any*/),
          (v24/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v32/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "draftVersion",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/)
            ]
          },
          (v42/*: any*/),
          (v47/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ViewPageCommentsPanelPermission_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "commentsPanelPermission"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ArchivedPageBannerV2Status_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "archivedPageBannerStatusFragment"
          },
          {
            "condition": "useContentModeFragment",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ContentModeFragmentProvider_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "viewPageContentMode"
              }
            ]
          },
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "useNewContentTopper",
                          "variableName": "useNewContentTopper"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "ContentTitleWithByLine_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentTitleWithByLine"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useTitleContentPropertiesForPublishedPage_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererTitleContentProperties"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "CoverPictureQuery_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "rendererCoverPicture"
              }
            ]
          },
          {
            "condition": "includeAutomationDiscoveries",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "MeetingNotesAutomationDiscoveryFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "meetingNotesAutomationDiscoveryFragment"
              }
            ]
          },
          {
            "condition": "useNewContentTopper",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v51/*: any*/),
                    (v52/*: any*/),
                    (v54/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "titleContentProperties"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v55/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "coverPicture"
              },
              (v51/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v56/*: any*/),
                    (v57/*: any*/),
                    (v58/*: any*/),
                    (v27/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "shareAndRestrictButtonData"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v56/*: any*/),
                    (v58/*: any*/),
                    (v57/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageRestrictionsContext"
              }
            ]
          },
          {
            "condition": "preloadLabels",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageLabelsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "viewPageLabels"
              },
              {
                "args": (v59/*: any*/),
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  (v60/*: any*/),
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v61/*: any*/),
                      (v22/*: any*/),
                      (v62/*: any*/)
                    ]
                  }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              }
            ]
          },
          {
            "condition": "includeReactions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v63/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "reactionsContent"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ReactionsContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "reactionsContentFragment"
              }
            ]
          },
          {
            "condition": "includeRestrictionAncestors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v64/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageRestrictionsContextAncestors"
              }
            ]
          },
          {
            "condition": "includeClassification",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "BylineClassification_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "bylineClassificationFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v65/*: any*/)
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentClassification"
              }
            ]
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_content"
                }
              ],
              "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          },
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v66/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v37/*: any*/)
                  }
                ]
              },
              (v67/*: any*/)
            ]
          },
          (v68/*: any*/),
          (v69/*: any*/)
        ]
      },
      {
        "args": (v70/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_space"
                }
              ],
              "type": "Space"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          },
          (v16/*: any*/),
          (v71/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v82/*: any*/),
                  (v85/*: any*/)
                ]
              }
            ]
          },
          (v86/*: any*/),
          (v87/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v11/*: any*/),
      (v14/*: any*/),
      (v9/*: any*/),
      (v13/*: any*/),
      (v10/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v21/*: any*/),
          (v24/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v32/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v90/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/)
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "draftVersion",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v90/*: any*/),
              (v39/*: any*/)
            ]
          },
          (v42/*: any*/),
          (v47/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "emojiTitlePublished",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "emoji-title-published"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v48/*: any*/),
                "storageKey": "properties(key:\"emoji-title-published\")"
              },
              {
                "alias": "editorProperty",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "editor"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v28/*: any*/),
                      (v25/*: any*/)
                    ]
                  }
                ],
                "storageKey": "properties(key:\"editor\")"
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v53/*: any*/),
                  (v91/*: any*/)
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "homepageId"
                  }
                ]
              },
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v66/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v94/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v94/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v94/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v93/*: any*/),
                      (v92/*: any*/)
                    ]
                  }
                ]
              },
              (v67/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v55/*: any*/)
            ]
          },
          {
            "condition": "includeAutomationDiscoveries",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v91/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "useNewContentTopper",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v51/*: any*/),
              (v52/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/)
            ]
          },
          {
            "condition": "preloadLabels",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v59/*: any*/),
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  (v60/*: any*/),
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v88/*: any*/),
                      (v16/*: any*/),
                      (v61/*: any*/),
                      (v22/*: any*/),
                      (v62/*: any*/)
                    ]
                  }
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              }
            ]
          },
          {
            "condition": "includeReactions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v63/*: any*/)
            ]
          },
          {
            "condition": "includeRestrictionAncestors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v64/*: any*/)
            ]
          },
          {
            "condition": "includeClassification",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v65/*: any*/)
            ]
          },
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v66/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v89/*: any*/)
                  }
                ]
              },
              (v67/*: any*/)
            ]
          },
          (v68/*: any*/),
          (v69/*: any*/)
        ]
      },
      {
        "args": (v70/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v71/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v31/*: any*/)
              },
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v72/*: any*/),
                      (v80/*: any*/),
                      (v81/*: any*/),
                      (v79/*: any*/),
                      (v73/*: any*/),
                      (v74/*: any*/),
                      (v78/*: any*/),
                      (v75/*: any*/),
                      (v77/*: any*/),
                      (v76/*: any*/),
                      (v84/*: any*/),
                      (v83/*: any*/)
                    ]
                  },
                  (v82/*: any*/),
                  (v85/*: any*/)
                ]
              }
            ]
          },
          (v86/*: any*/),
          (v87/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ad62a06f6aa5632bfaade277e2ee9001",
    "id": "c08aa1d76373e829f3bf7d2981babc4dbd15e62e4c9d7edeba93ba1675273988",
    "metadata": {},
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$includeAutomationDiscoveries:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$useContentModeFragment:Boolean=false){spaceHomepage(spaceKey:$spaceKey,version:$versionOverride){...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors)\n    ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n    ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n    pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n    coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n    hasInheritedRestrictions@include(if:$includeRestrictions)\n    hasRestrictions@include(if:$includeRestrictions)\n    hasViewRestrictions@include(if:$includeRestrictions)\n    title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n    labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n    contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n    ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeRestrictionAncestors)\n    ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content@include(if:$includeClassification)\n    id@include(if:$includeClassification)\n    classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n    contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}},space(key:$spaceKey){...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
  }
};
})();

(node as any).hash = "8e89f6746f4a01f675185855219f37bc";

export default node;
